import { connect } from 'react-redux';

import { selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { fetchProposalItems } from '@/store/reducers/dictionaries/actions';
import { selectProposalItems } from '@/store/reducers/dictionaries/selectors';
import { closeSubmitOrderModal } from '@/store/reducers/global/actions';
import { selectSubmitOrderModalConfig } from '@/store/reducers/global/selectors';
import { clearOpportunity, fetchOpportunity } from '@/store/reducers/opportunities/actions';
import { selectNewOpportunity } from '@/store/reducers/opportunities/selectors';
import { clearCalculatedTax, clearCreatedOrderId } from '@/store/reducers/orders/actions';
import { fetchDesignToOrderProducts } from '@/store/reducers/products/actions';
import {
  selectDesignToOrderProducts,
  selectProductLineName,
} from '@/store/reducers/products/selectors';
import { selectProposal } from '@/store/reducers/proposals/selectors';
import { fetchShippingAddresses } from '@/store/reducers/shipping-addreses/actions';
import {
  selectHomeOwnerAddress,
  selectNewShippingAddresses,
} from '@/store/reducers/shipping-addreses/selectors';
import { AppState } from '@/types';

import { SubmitOrderModal as Component } from './SubmitOrderModal';

const mapStateToProps = (state: AppState) => ({
  allPriceBookEntries: selectDesignToOrderProducts(state),
  allShippingAddresses: selectNewShippingAddresses(state),
  homeownerAddress: selectHomeOwnerAddress(state),
  loadingModalDataInProgress:
    selectRequestStatus(state, 'opportunities|fetchById') ||
    selectRequestStatus(state, 'dictionaries|fetchProposalItems') ||
    selectRequestStatus(state, 'products|fetchDesignToOrderEntries'),
  modalConfig: selectSubmitOrderModalConfig(state),
  opportunity: selectNewOpportunity(state),
  productLineName: selectProductLineName(state),
  proposal: selectProposal(state),
  proposalItems: selectProposalItems(state),
});

const mapActionsToProps = {
  clearCalculatedTax,
  clearCreatedOrderId,
  clearOpportunity,
  closeSubmitOrderModal,
  fetchDesignToOrderProducts,
  fetchOpportunity,
  fetchProposalItems,
  fetchShippingAddresses,
};

export const SubmitOrderModal = connect(mapStateToProps, mapActionsToProps, null, {
  forwardRef: true,
})(Component);
